import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Rating } from '@care/react-component-lib';
import { AmplitudeEvent, trackAmplitudeEvent, SeoFeatureInteracted } from '@/lib/analyticsHelper';
import { getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_caregiverSearchResults_latestReview as LatestReviewType } from '@/__generated__/getSearchResults';
import ReadMore from '../ReadMore';

interface ProviderLatestReviewProps {
  latestReview: LatestReviewType;
  name: string;
}

const ProviderLatestReview = ({ latestReview, name }: ProviderLatestReviewProps) => {
  const {
    reviewer: { displayName: reviewerDisplayName },
    rating,
    comment,
  } = latestReview;

  const currentRating = rating.toFixed(1);

  const [isExpanded, setIsExpanded] = useState(false);

  const amplitudeTrackingForShowMoreReview = () => {
    const amplitudeData: SeoFeatureInteracted = {
      feature_name: 'Show More Review Content',
    };

    trackAmplitudeEvent(AmplitudeEvent.seoFeatureInteracted, amplitudeData);
  };

  return (
    <>
      <Box
        mb={1}
        display={{ xs: 'block', sm: 'flex' }}
        sx={{
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontWeight: 700,
        }}>
        <Box mb={{ xs: 1 }}>
          <Typography variant="h3">{name}</Typography>
        </Box>
        <Box
          sx={{
            display: 'block',
            whiteSpace: 'nowrap',
          }}>
          <Rating name="size-medium" defaultValue={parseFloat(currentRating)} readOnly />
          <Typography variant="h3">{currentRating}</Typography>
        </Box>
      </Box>
      <Box ml={{ sm: 4 }}>
        <ReadMore
          gutterBottom
          color="textPrimary"
          component="div"
          variant="body2"
          charLimit={300}
          value={comment || ''}
          showMoreLabel={isExpanded ? 'Less' : 'show more'}
          onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
            const target = e.target as HTMLAnchorElement;
            if (target.tagName.toLowerCase() === 'button') {
              setIsExpanded(!isExpanded);
              if (!isExpanded) {
                amplitudeTrackingForShowMoreReview();
              }
            }
          }}
        />
        <Box mt={1} textAlign="right">
          <Typography variant="body2">- {reviewerDisplayName || 'Care member'}</Typography>
        </Box>
      </Box>
    </>
  );
};

export default ProviderLatestReview;
